<template>
    <div>
        <div>
            <div>
                <h4 class="">
                    Quality Checks
                </h4>
                <hr class="mb-4">
                <!--<div class="col col-4 align-right text-end">-->
                    <!--<button class="btn btn-primary">Add</button>-->
                <!--</div>-->
            </div>
            <div v-if="canCreateProofpointQualityChecks">
                <div v-for="c in checks" :key="c.id" >
                    <QualityCheckForm
                        :c="c"
                        :get-severity="getSeverity"
                        :network-activity="networkActivity"
                        :save="save"
                        :is-new-check="false"
                    />
                </div>
                <div v-if="isAddingNewCheck">
                    <QualityCheckForm
                        :c="newCheck"
                        :get-severity="getSeverity"
                        :network-activity="networkActivity"
                        :save="submitNewProofpointCheck"
                        :is-new-check="true"
                    />
                </div>
                <button class="btn btn-primary" :disabled="networkActivity" @click="showNewCheckForm">
                    Add new quality check
                </button>
            </div>
        </div>
    </div>
</template>

<style>

.em1 {
    font-size: inherit !important;
}
.integration-list {
    list-style-type: none;
    padding-left: 0;
}
.integration-list .btn {
    margin-left: 10px;
}

</style>

<script>
import HasGlobalQualityCheckList from '@/components/QualityChecks/HasGlobalQualityCheckList'
import * as toastr from "toastr";
import IntegrationLoader from '@/components/DataManagement/IntegrationLoader'
import {mapGetters} from 'vuex'
import QualityCheckForm from "@/components/QualityChecks/QualityCheckForm.vue";

const Severity = {
        PASS : {key: 0, label: 'PASS'},
        FLAG : {key: 1, label: 'FLAG'},
        FAIL : {key: 2, label: 'FAIL'},
        INCONCLUSIVE :{key:  5, label: 'INCONCLUSIVE'},
        ERROR : {key: 6, label: 'ERROR'},
    };
    Severity.list =  [
        Severity.PASS,
        Severity.FLAG,
        Severity.FAIL,
        Severity.INCONCLUSIVE,
        Severity.ERROR
    ];
    Severity.lookup =  Severity.list.reduce((all, severity) => ({...all, [severity.key]: severity.label}), {});

    export default {
        components: {QualityCheckForm},
        mixins: [HasGlobalQualityCheckList, IntegrationLoader],
        props: { account: Object },
        async mounted() {
            console.log(Severity);
            console.log(this);
            this.load();
        },
        computed: {
            ...mapGetters({
                currentAccountOverview: 'currentAccountOverview',
            }),
            promptProofpointAuthentication() {
                return !this.authenticatedProofpoint && this.featuresForAccount.proofpoint && this.featuresForAccount.qualityChecks
            },
            promptSales() {
                return !this.featuresForAccount.proofpoint || !this.featuresForAccount.qualityChecks
            }

        },
        data() {
            return {
                checks: [],
                networkActivity: false,
                newCheck: {
                    newName: null,
                    newId: null,
                    meta: {
                        should_send_to_syndicate: false,
                        external_ids: {
                            success_flag: null,
                        }
                    },
                    default: false,
                    statuses: [
                        {
                            severity: 1,
                            //"status_key": "flag",
                            status_label: "Proofpoint Exception",
                            //"icon_url": null,
                            icon_class: "fa fa-flag",
                            tag_class: "bg-warning",
                            //"level": 1000,
                            //"meta": {},
                        },
                        {
                            severity: 2,
                            //"status_key": "fail",
                            status_label: "Proofpoint Failed",
                            //"icon_url": null,
                            icon_class: "fa fa-times-circle",
                            tag_class: "bg-danger",
                            //"level": 2000,
                            //"meta": {},
                        },
                        {
                            severity: 5,
                            //"status_key": "inconclusive",
                            status_label: "Proofpoint Inconclusive",
                            //"icon_url": null,
                            icon_class: "fa fa-question-circle",
                            tag_class: "bg-light text-dark",
                            //"level": 5000,
                            //"meta": {},
                        },
                        {
                            severity: 6,
                            //"status_key": "inconclusive",
                            status_label: "Proofpoint Inconclusive",
                            //"icon_url": null,
                            icon_class: "fa fa-question-circle",
                            tag_class: "bg-light text-dark",
                            //"level": 6000,
                            //"meta": {},
                        },
                        {
                            severity: 0,
                            // "status_key": "pass",
                            status_label: "Proofpoint Awesome",
                            //"icon_url": null,
                            icon_class: "fa fa-check-circle",
                            tag_class: "bg-success",
                            //"level": 0,
                            //"meta": {},
                        }
                    ],


                },
                isAddingNewCheck: false,
            }
        },
        watch: {
            account() {
                this.load()
            }
        },
        methods: {
            async load() {
                this.reloadIntegrationData();
                this.checks = this.$sort.alphabetize(await this.fetchChecksAndInitializeDoNotExist(), 'created').map(c => ({...c, statuses: this.$sort.alphabetize(c.statuses, 'severity')}))
            },
            getSeverity(key) {
                console.log(Severity)
                return Severity.lookup[key]|| '';
            },

            integrationByName(name) {
                return this.metaIntegrations[name]
            },
            async save(check) {
                console.log('* QualityChecks save check', check)
                this.networkActivity = 'Saving...';
                let error = check.statuses.find(x => x.severity === Severity.ERROR.key);
                let inconclusive = check.statuses.find(x => x.severity === Severity.INCONCLUSIVE.key);
                if (error && inconclusive) {
                    error.status_label = inconclusive.status_label;
                }
                await this.$api.put(`/quality-checks/${check.id}`, check);
                await this.$api.put(`/quality-checks/${check.id}/statuses`, check)
                this.networkActivity = false;
                toastr.success("Saved quality check successfully!")
            },
            showNewCheckForm() {
                this.isAddingNewCheck = true;
            },
            async submitNewProofpointCheck() {
                this.networkActivity = true;
                console.log('* QualityChecks submitNewProofpointCheck', this.checks);
                try {
                    const body = {
                        name: this.newCheck.name,
                        default: this.newCheck.default,
                        type: 'proofpoint',
                        meta: {
                            should_send_to_syndicate: this.newCheck.meta.should_send_to_syndicate,
                            external_ids: this.newCheck.meta.external_ids
                        }
                    };
                    await this.$api.post(`/accounts/${this.currentAccountOverview.id}/quality-checks`, body);
                    toastr.success("Successfully added new quality check!");
                    this.isAddingNewCheck = false;
                    await this.load(); // refresh the list
                } catch (e) {
                    console.error('Error adding new Quality check:', e)
                    toastr.error("Failed to add new quality check.");
                } finally {
                    this.networkActivity = false;
                }
            },
        }

    }
</script>
